/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useSelector } from 'react-redux';
import useTabCommandPipeline from 'modules/common/ui-controller/hooks/use-tab-command-pipeline';
import { selectResetBookingDate } from 'modules/dashboard/selectors';
import { selectActivePaceTab, selectPaceBookingPaceWindow } from '../selectors';
import PACE_COMMAND_STEPS from './pace-command-steps';

/**
 * Custom hook to execute pace tab filter command flow, see PACE_COMMAND_STEPS for the order
 * @param {Number} tabValue - active tab value
 * @param {Number} ownTabValue - tab value of the pace tab the filter panel belongs to
 * @param {Object} filters - filter panel state the commands read: isLoaded, chartBreakdownList,
 * focusOnList, isFocusOnListReady, paceList, percentageList, visualFilters, customBooking,
 * dateComparison, hotelList, hotelGroupList, handleComparisonChange, handleToggleChange
 */
const usePaceCommandPipeline = (tabValue, ownTabValue, filters) => {
  const paceWindowSelection = useSelector(selectPaceBookingPaceWindow);
  const resetBookingDate = useSelector(selectResetBookingDate);
  const activeTab = useSelector(selectActivePaceTab);
  //
  useTabCommandPipeline(
    PACE_COMMAND_STEPS,
    { ...filters, paceWindowSelection, resetBookingDate, activeTab },
    tabValue,
    // pace and pace test tabs have a filter panel each, only the one of the active tab applies
    [ownTabValue]
  );
};

export default usePaceCommandPipeline;
